/* eslint-disable react/no-danger */
/* @flow strict */

import * as React from 'react';
import './terms.scss';

type PropsType = {
    isOpen: boolean,
    content: string,
    handleClose: () => void
};

const TermsModal = (props: PropsType): React.Element<'div'> => {
    const { isOpen, content, handleClose } = props;

    return (
        <div className={`sparxo-checkout-TermsModal_container ${isOpen ? 'sparxo-checkout-TermsModal_show' : ''}`}>
            <div className="sparxo-checkout-TermsModal_title">Terms and conditions</div>
            <div className="sparxo-checkout-TermsModal_closeBtn" onClick={(): void => handleClose()} />
            <div className="sparxo-checkout-TermsModal_content" dangerouslySetInnerHTML={{ __html: content }} />
        </div>
    );
};

export default TermsModal;
